// Preact vendor bundle entry point
// Re-exports all Preact modules for use by component scripts
import * as preact from 'preact';
import * as hooks from 'preact/hooks';
import * as jsxRuntime from 'preact/jsx-runtime';

// Export everything from preact as the default export
export default {
  ...preact,
  ...hooks,
  ...jsxRuntime,
};
